export default {"src":"/_next/static/media/right-arrow.5fb9baa0.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};